export enum SharedPromotionQueryEnum {
  PROMOTIONS_LIST = 'PROMOTIONS_LIST',
}
